export const functionCode = `function addList() { //... } 
const deleteList = () => { //... }`;

export const classCode = `class Board {
    constructor() {
    }
}`;

export const moduleCode = `import kanbanService from './kanban.service.js'
const kanbanService = require('./kanban.service.js'`;



// WEBPACK FOOTER //
// ./src/slides/02-unit-testing/01-introduction/code-examples/03-function-example.js